module.exports = "\nvg-player {\n  border: 1px solid #949799;\n}\n\n/* IE hack */\n\nvg-controls vg-scrub-bar {\n  top: 0;\n  background: none;\n}\n\n.video-header {\n  height: 50px;\n  position: relative;\n  top: 0;\n  left: 0;\n  z-index: 100;\n}\n\n.video-title {\n  float: left;\n  font-family: Open Sans Regular, Helvetica Neue, sans-serif;\n  font-weight: 400;\n  font-size: 2rem;\n  color: #949799;\n}\n\n.close-button {\n  background-color: #949799;\n  color: #fff;\n  margin-bottom: 10px;\n}\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/video-player-dialog.component.css
// module id = ./src/app/components/video-player-dialog.component.css
// module chunks = main